module.exports = __webpack_public_path__ + "static/hyperterm-382006622595e731d3f3999c62f4eacf.png";